'use client';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { Circle } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/lib/utils';

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn('grid gap-2', className)}
      {...props}
      ref={ref}
    />
  );
});

RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & { radioClasses?: string }
>(({ className, radioClasses, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'ring-offset-background focus-visible_ring-ring aspect-square h-4 w-4 rounded-full border border-primary text-primary focus_outline-none focus-visible_ring-2 focus-visible_ring-offset-2 disabled_cursor-not-allowed disabled_opacity-50',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className='flex items-center justify-center'>
        <Circle className={cn('h-2.5 w-2.5 fill-[#da6950] text-[#da6950]', radioClasses)} />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});

const RadioGroupItem2 = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'ring-offset-background focus-visible_ring-ring aspect-square h-[18px] w-[18px] border border-primary text-primary focus_outline-none focus-visible_ring-2 focus-visible_ring-offset-2 disabled_cursor-not-allowed disabled_opacity-50',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className='relative flex items-center justify-center'>
        <svg
          className='absolute left-0 top-[-8px] bg-black'
          width='16'
          height='16'
          viewBox='0 0 16 12'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M13.796 0.667775C13.4259 0.278805 12.819 0.271292 12.4408 0.651247L5.91033 7.20646L2.53769 3.73935C2.18741 3.37892 1.60029 3.39883 1.22578 3.78367C0.851273 4.16832 0.83174 4.77234 1.1824 5.13258L5.30518 9.37087C5.65527 9.73073 6.24258 9.71082 6.61709 9.32617C6.70292 9.23808 6.76715 9.13816 6.81524 9.03242C6.85224 9.00463 6.88924 8.97833 6.92285 8.94434L13.7801 2.06138C14.1589 1.68086 14.1657 1.05731 13.796 0.667775Z'
            fill='white'
          />
        </svg>

        {/* <svg
          className='absolute left-0 top-[-12px]'
          width='21'
          height='18'
          viewBox='0 0 21 18'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M0.923828 8.235L6.91236 11.55L20.1546 0.5L7.58712 17.5L0.923828 8.235Z'
            fill='#093047'
          />
        </svg> */}
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem, RadioGroupItem2 };
